import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '../utils/analytics';

/**
 * Scrolls the window to the top on every route change.
 * Also pushes a virtual pageview to GTM dataLayer for analytics.
 * Place inside <Router> but outside <Routes>.
 */
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
    // Push virtual pageview for SPA navigation — title may update async via Helmet,
    // so use a short delay to capture the updated document.title
    const timer = setTimeout(() => {
      trackPageView(pathname, document.title);
    }, 100);
    return () => clearTimeout(timer);
  }, [pathname]);

  return null;
};

export default ScrollToTop;
